import * as React from "react";

import AppModals from "@app/AppModals";
import EmptyLayout from "@v1/layouts/EmptyLayout";
import { Loader } from "@v2/components/Loader";
import { PendingShopifyIntegrationModal } from "@v2/features/settings/shop/modals/PendingShopifyIntegrationModal";
import useConnectShopifyIntegrationNavigator from "@v2/hooks/useConnectShopifyIntegrationNavigator";

const ShopifyPendingAppInstallationLayout = () => {
  const {
    shouldShowPendingIntegrationModal,
    setShouldShowPendingIntegrationModal,
  } = useConnectShopifyIntegrationNavigator();

  return (
    <EmptyLayout>
      <Loader />
      <AppModals />
      <PendingShopifyIntegrationModal
        open={shouldShowPendingIntegrationModal}
        onOpenChange={setShouldShowPendingIntegrationModal}
      />
    </EmptyLayout>
  );
};

export default ShopifyPendingAppInstallationLayout;
